import React from "react";

import SubcategoryList from "./SubcategoryList";
import SubcategoryAdd from "./SubcategoryAdd";
import SubcategoryEdit from "./SubcategoryEdit";


class Subcategory extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            category: props.category,
            listMode: true,
            selectedRecord: null,
            breadCrumbArr:[]
        }
        this.toggleListMode = this.toggleListMode.bind(this);
        this.onEditSubcategory = this.onEditSubcategory.bind(this);
        this.onUpdateSubcategory = this.onUpdateSubcategory.bind(this);
        this.onRemoveBreadCrumb = this.onRemoveBreadCrumb.bind(this);

    }

    toggleListMode(mode){
        if(mode){
            this.setState({ listMode : mode, selectedRecord : null });
        }
        this.setState({ listMode : mode });
    }

    onEditSubcategory(data){
        this.setState({ listMode: false, selectedRecord: data})
    }

    onUpdateSubcategory(subcategory){
        this.state.breadCrumbArr.push(subcategory);
        this.setState({ category: subcategory})
    }

    onRemoveBreadCrumb(data, index){
        var tempArr=[]
        for(let i=0; i<=index; i++){
            tempArr.push(this.state.breadCrumbArr[i]);
        }
        this.setState({ category: data, breadCrumbArr: tempArr});
    }

    componentDidMount(){
        this.state.breadCrumbArr.push(this.props.category);
    }

    componentDidUpdate(prevProps){
        if(prevProps.category !== this.props.category){
            this.setState({category: this.props.category});
        }
    }

    render() {
        const { category, listMode, selectedRecord, breadCrumbArr } = this.state;
        return (
            <div className="tab-pane fade show active" id="serv" role="tabpanel" aria-labelledby="serv-tab">
                <div className="box-card">
                    <div className="row">
                        <div className="col-md-12">
                            {listMode ?
                                <SubcategoryList
                                    category={category}
                                    breadCrumbArr={breadCrumbArr}
                                    toggleMode={this.toggleListMode}
                                    onEditSubcategory={this.onEditSubcategory}
                                    onUpdateSubcategory={this.onUpdateSubcategory}
                                    onRemoveBreadCrumb={this.onRemoveBreadCrumb}
                                />
                                :
                                <>
                                {selectedRecord ?
                                    <SubcategoryEdit
                                        category={category}
                                        breadCrumbArr={breadCrumbArr}
                                        toggleMode={this.toggleListMode}
                                        selectedRecord={selectedRecord}
                                        onRemoveBreadCrumb={this.onRemoveBreadCrumb}
                                    />
                                :
                                    <SubcategoryAdd
                                        category={category}
                                        breadCrumbArr={breadCrumbArr}
                                        toggleMode={this.toggleListMode}
                                        onRemoveBreadCrumb={this.onRemoveBreadCrumb}
                                    />
                                }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
  }
  
  export default Subcategory;  